/**
 * CategoryTabs — dynamic pill-tab bar.
 * Derives unique categories from `items` and includes "All" as the default.
 */
export default function CategoryTabs({ items, active, onChange, testId = "cat-tabs" }) {
    const unique = new Set();
    items.forEach((it) => {
        const c = (it.category || "").trim();
        if (c) unique.add(c);
    });
    const cats = ["All", ...Array.from(unique).sort((a, b) => a.localeCompare(b))];

    if (cats.length <= 1) return null;

    return (
        <div data-testid={testId} className="flex gap-2 flex-wrap px-6 lg:px-10 mb-4">
            {cats.map((c) => (
                <button
                    key={c}
                    data-testid={`${testId}-${c.replace(/\s+/g, "-").toLowerCase()}`}
                    onClick={() => onChange(c)}
                    className={`text-xs font-semibold px-4 py-2 rounded-full transition-colors ${
                        active === c
                            ? "bg-[#FFD400] text-black"
                            : "bg-white/5 text-white/80 border border-white/10 hover:bg-white/10"
                    }`}
                >
                    {c}
                </button>
            ))}
        </div>
    );
}
